<script lang="ts">
	//UI
	import StoreNameValue from "./StoreNameValue.svelte";
	import RegistrationImage from "./RegistrationImage.svelte";
	import { TopBottom } from "@hitit/new_ui";
	//Utils
	import {
		formatKoreanRegistrationNumberHandler,
		addKoreanRegisterSpacer,
	} from "@hitit/hub/src/v7/utils";
	import { t } from "@hitit/hub/src/stores";

	//Props
	export let editmode = false;
	export let registrationNumber = "";
	export let registrationImage = "";
	export let ownername = "";
	export let storeType = "";
	export let storeName = "";
	export let storeClass = "";
	export let storeAddr = "";
	export let contactName = "";
	export let contactEmail = "";
	export let contactPhone = "";
	// Constants
	// Variables
	let openRegistration = false;
	// Functions
	function idHanlder(_: HTMLElement, replacedValue: string) {
		registrationNumber = replacedValue;
	}

</script>

<div class="container" t-id="KoreaRegistration">
	<div
		id="open-button"
		class:openRegistration
		on:click={() => (openRegistration = !openRegistration)}>
		<TopBottom top={openRegistration} />
	</div>
	<div class="registration-image">
		<div class="title-wrapper">
			<img src="/img/icons/korea-registration.png" alt="description" />
			<h3>{$t('hub.store.ko_registration.image')}</h3>
		</div>
		{#if openRegistration}
			<RegistrationImage
				editmode={editmode}
				bind:imageaddr={registrationImage} />
		{/if}
	</div>
	{#if openRegistration}
		<div class="name-value" t-id={'registration-id'}>
			<StoreNameValue
				length={12}
				on:input={(e) => formatKoreanRegistrationNumberHandler(e, idHanlder)}
				name={$t('hub.store.ko_registration.id')}
				value={addKoreanRegisterSpacer(registrationNumber)}
				editmode={editmode} />
		</div>
		<div class="name-value">
			<StoreNameValue
				name={$t('hub.store.ko_registration.name')}
				value={storeName} />
		</div>
		<div class="name-value">
			<StoreNameValue
				name={$t('hub.store.ko_registration.type')}
				value={storeType} />
		</div>
		<div class="name-value">
			<StoreNameValue
				name={$t('hub.store.ko_registration.image')}
				value={storeClass} />
		</div>
		<div class="name-value">
			<StoreNameValue
				name={$t('hub.store.ko_registration.ownername')}
				value={ownername} />
		</div>
		<div class="name-value">
			<StoreNameValue
				name={$t('hub.store.ko_registration.address')}
				value={storeAddr} />
		</div>
		<div class="name-value">
			<StoreNameValue
				name={$t('hub.store.ko_registration.contact_name')}
				value={contactName} />
		</div>
		<div class="name-value">
			<StoreNameValue
				name={$t('hub.store.ko_registration.contact_phonenumber')}
				value={contactPhone} />
		</div>
		<div class="name-value">
			<StoreNameValue
				name={$t('hub.store.ko_registration.contact_email')}
				value={contactEmail} />
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		position: relative;
		.name-value {
			width: 100%;
		}

		.registration-image {
			display: flex;
			flex-direction: column;
			gap: 10px;
			width: 100%;
		}

		.title-wrapper {
			display: flex;
			align-items: center;
			gap: 10px;

			img {
				width: 24px;
				height: 24px;
			}

			h3 {
				padding-bottom: 3px;
				font-size: 1.25rem;
				font-weight: 500;
				color: #46474b;
				@include appleAdjustTextForSize(20);
			}
		}

		#open-button {
			width: 27.8px;
			height: 14px;
			position: absolute;
			top: 4px;
			right: 0px;

			&:hover {
				cursor: pointer;
			}

			&.openRegistration {
				bottom: 0px;
				top: auto;
			}
		}
	}

	@include DesktopSize {
		.container {
			gap: 30px 0px;
			padding-bottom: 24px;

			.registration-image {
				gap: 30px;
			}

			.title-wrapper {
				h3 {
					@include appleAdjustTextForSize(20, false);
				}
			}

			#open-button {
				top: auto;
				right: auto;
				bottom: 0px;
				left: 50%;
				transform: translate(-50%, 0%);
			}

			.name-value {
				width: 50%;
				max-width: 50%;
			}
		}
	}

</style>
